<template>
	<div class="rechargeStatistics">
		<div class="itemTitleBox disStart">
			<span class="title">充值统计</span>
		</div>
		<div class="contentBox">
			<ul class="topBox scrollUl" ref="scrollview">
				<li class="scrollLi disBetween">
					<div class="imgBox img7"></div>
					<div class="itemBox ">
						<div class="valueBox">
							累计充值金额
						</div>
						<div class="valueBox">
							<span>{{recordObj.coinAmount}}</span>元
						</div>
					</div>
				</li>

				<li class="scrollLi disBetween">
					<div class="imgBox img9"></div>
					<div class="itemBox ">
						<div class="valueBox">
							账面充值金额
						</div>
						<div class="valueBox">
							<span>{{recordObj.accountBalance}}</span>元
						</div>
					</div>
				</li>
				<li class="scrollLi disBetween">
					<div class="imgBox img11"></div>
					<div class="itemBox ">
						<div class="valueBox">
							已使用充值金
						</div>
						<div class="valueBox">
							<span>{{recordObj.consumeAmount}}</span>元
						</div>
					</div>
				</li>
				<li class="scrollLi disBetween pareElement">
					<div class="imgBox img8"></div>
					<div class="itemBox ">
						<div class="valueBox disStart tsIcon">
							累计赠送金额
						</div>
						<div class="valueBox">
							<span>{{$newNumber((recordObj.extraCoinAmount ||0 ),(recordObj.otherExtraCoinAmount||0))}}</span>元
						</div>
					</div>
					<div class="hoverBox itemBox">
						<div class="disStart">
							<div class="valueBox">
								累计充值赠送金额
							</div>
							<div class="valueBox">
								<span>{{recordObj.extraCoinAmount}}</span>元
							</div>
						</div>
						<div class="disStart">
							<div class="valueBox">
								累计其他赠送金额
							</div>
							<div class="valueBox">
								<span>{{recordObj.otherExtraCoinAmount}}</span>元
							</div>
						</div>
					</div>
				</li>

				<li class="scrollLi disBetween ">
					<div class="imgBox img10"></div>
					<div class="itemBox ">
						<div class="valueBox ">
							账面赠送金余额
						</div>
						<div class="valueBox">
							<span>{{recordObj.accountExtraBalance}}</span>元
						</div>
					</div>
				</li>
				<li class="scrollLi disBetween pareElement">
					<div class="imgBox img12"></div>
					<div class="itemBox ">
						<div class="valueBox disStart tsIcon">
							已使用赠送金
						</div>
						<div class="valueBox">
							<span>{{$newNumber((recordObj.consumeExtraAmount ||0 ),(recordObj.cancelExtraAmount||0))}}</span>元
						</div>
					</div>
					<div class="hoverBox itemBox">
						<div class="disStart">
							<div class="valueBox ">
								已使用赠送金
							</div>
							<div class="valueBox">
								<span>{{recordObj.consumeExtraAmount}}</span>元
							</div>
						</div>
						<div class="disStart">
							<div class="valueBox">
								已作废赠送金
							</div>
							<div class="valueBox">
								<span>{{recordObj.cancelExtraAmount||0}}</span>元
							</div>
						</div>
					</div>
				</li>
			</ul>
			<div class="botBox">
				<div class="titleBox disBetween">
					<span class="title">流水情况</span>
					<div class="btnBox disBetween">
						<div class="timeType disStart">
							<span class="disCenter" :class="{active:active==1}" @click="active=1">年</span>
							<span class="disCenter" :class="{active:active==2}" @click="active=2">月</span>
						</div>
						<div class="myinputBox myinputBox2">
							<el-date-picker :editable="clearable" :clearable="clearable" @change="changeTime"
								v-show="active==1" v-model="searchDataYear" value-format="yyyy" type="year"
								placeholder="选择日期">
							</el-date-picker>
							<el-date-picker :editable="clearable" :clearable="clearable" @change="changeTime"
								v-show="active==2" v-model="searchDataMonth" value-format="yyyy-MM" type="month"
								placeholder="选择日期">
							</el-date-picker>
						</div>
						<el-button type="success" @click="rechargeSituation">查询</el-button>
					</div>
				</div>
				<div class="echartBox" id="myEcharts" v-loading="loading">

				</div>
			</div>
		</div>
	</div>

</template>

<script type="text/javascript">
	import {
		timestampToDate
	} from "../../../../assets/js/common.js"
	export default {
		name: "rechargeStatistics",
		components: {},
		data() {
			return {
				active: 2,
				clearable: false,
				searchDataYear: "2023",
				searchDataMonth: "2023-05",
				recordObj: {
					accountBalance: "",
					accountExtraBalance: "",
					coinAmount: "",
					extraCoinAmount: "",
				},
				loading: false,
				echartAobj: {
					colorList: ['#5999FF', '#4DC85A', '#FF6966', '#B06DFF', '#FFA231', '#f071ff', '#00AFAD'],
					dateList: [],
					coinAmountList: [],
					extraCoinAmountList: [],
					withdrawalAmountList: [],
					weChatAmountList: [],
					totalRevenueAmountList: [],
				},
			}
		},
		watch: {
			active(n) {
				this.$nextTick(() => {
					// this.rechargeSituation()
				})
			}
		},
		mounted() {
			this.$set(this, "searchDataYear", timestampToDate(new Date()).slice(0, 4))
			this.$set(this, "searchDataMonth", timestampToDate(new Date()).slice(0, 7))
			this.$nextTick(() => {
				this.getDate()
				this.rechargeSituation()
			})
		},
		methods: {
			getDate() {
				this.$api.rechargeStatistics({}).then((res) => {
					if (res.returnCode == 200) {
						console.log(res)
						this.$set(this, "recordObj", res.obj)
					}
				})
			},
			changeTime(n) {
				if (this.active == 1) {
					this.$set(this, "searchDataYear", n)
				} else {
					this.$set(this, "searchDataMonth", n)
				}
				// this.$nextTick(() => {
				// 	this.rechargeSituation()
				// })
			},
			rechargeSituation() {
				let obj = {
					type: this.active,
					date: ""
				}
				this.loading = true
				this.$set(this.echartAobj, "dateList", [])
				this.$set(this.echartAobj, "withdrawalAmountList", [])//提现
				this.$set(this.echartAobj, "weChatAmountList", [])//微信
				this.$set(this.echartAobj, "coinAmountList", [])//充值
				this.$set(this.echartAobj, "cardAmountList", [])//电卡
				this.$set(this.echartAobj, "totalRevenueAmountList", [])//营收
				if (this.active == 1) {
					obj.date = this.searchDataYear
				} else {
					obj.date = this.searchDataMonth
				}
				this.$api.rechargeSituation(obj).then((res) => {
					if (res.returnCode == 200) {
						for (let k in res.obj.dateList) {
							if (this.active == 1) {
								this.$set(res.obj.dateList, [k], res.obj.dateList[k] + "月")
							} else {
								this.$set(res.obj.dateList, [k], res.obj.dateList[k] + "号")
							}
						}
						this.$set(this.echartAobj, "dateList", res.obj.dateList || [])
						this.$set(this.echartAobj, "withdrawalAmountList", res.obj.withdrawalAmountList || [])
						this.$set(this.echartAobj, "weChatAmountList", res.obj.weChatAmountList || [])
						this.$set(this.echartAobj, "cardAmountList", res.obj.cardAmountList || [])
						this.$set(this.echartAobj, "coinAmountList", res.obj.coinAmountList || [])
						this.$set(this.echartAobj, "totalRevenueAmountList", res.obj
							.totalRevenueAmountList || [])
						this.$nextTick(() => {
							this.initChart()
						})

					}
				})
			},
			initChart() {
				this.loading = false
				let that = this
				that.loading = false
				let getchart = that.$echarts.init(document.getElementById('myEcharts'));
				getchart.clear()
				var option = {
					color: that.echartAobj.colorList,
					legend: {
						data: ['收入', '提现'],
						textStyle: {
							align: 'right',
						},
						top: '2%',
						right: '2%',
					},

					tooltip: {
						trigger: 'axis',
						textStyle: {
							align: 'left' // 文字左对齐
						},
						formatter: function(params) {
							let str = `<div class="black" style="font-size:12px"><p>${params[0].axisValue}</p>
							<p class="disStart"><span style="width:10px;height:10px;border-radius:50%;background:#7AA1FF;margin-right:10px"></span>提现 ${params[0].data}</p>
								<p class="disStart"><span style="width:10px;height:10px;border-radius:50%;background:#FF6966;margin-right:10px"></span>收入 ${params[1].data}</p>
								<p class="disStart"><span style="width:10px;height:10px;margin-right:10px"></span>临时 ${that.echartAobj.weChatAmountList[params[0].dataIndex]}</p>
								<p class="disStart"><span style="width:10px;height:10px;margin-right:10px"></span>会员 ${that.echartAobj.coinAmountList[params[0].dataIndex]}</p>
								<p class="disStart"><span style="width:10px;height:10px;margin-right:10px"></span>电卡 ${that.echartAobj.cardAmountList[params[0].dataIndex]}</p>
							</div>`
							return str
						}
					},

					grid: {
						top: '20%',
						left: '10%',
						right: '5%',
						bottom: '15%',
					},
					xAxis: [{
						type: 'category',
						axisLine: {
							show: true,
						},
						splitArea: {
							// show: true,
							color: '#f00',
							lineStyle: {
								color: '#f00',
							},
						},
						splitLine: {
							show: false,
						},
						axisLabel: {
							margin: 10,
						},
						boundaryGap: false,
						data: that.echartAobj.dateList,
					}, ],

					yAxis: [{
						type: 'value',
						name: "金额",
						min: 0,
						// max: 140,
						splitNumber: 4,
						splitLine: {
							show: false,
							lineStyle: {
								show: true,
								color: '#e3e3e3',
							},
						},
						axisLine: {
							show: false,
						},
						axisLabel: {
							show: true,
						},
						axisTick: {
							show: false,
						},
					}, ],
					series: [{
							name: '提现',
							type: 'line',
							smooth: true, //是否平滑
							showAllSymbol: true,
							symbol: 'circle',
							symbolSize: 12,
							lineStyle: {
								normal: {
									color: '#7AA1FF',
								},
							},
							itemStyle: {
								color: '#7AA1FF',
								borderWidth: 3,
								borderColor: '#f3f3f3',
							},
							data: that.echartAobj.withdrawalAmountList,
						},
						{
							name: '收入',
							type: 'line',
							smooth: true, //是否平滑
							showAllSymbol: true,
							symbol: 'circle',
							symbolSize: 12,
							lineStyle: {
								normal: {
									color: '#FF6966',
								},
							},
							itemStyle: {
								color: '#FF6966',
								borderColor: '#fff',
								borderWidth: 3,
							},
							data: that.echartAobj.totalRevenueAmountList,
						},
					],
				};
				getchart.setOption(option);
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import "./rechargeStatistics.scss"
</style>